import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-components.compass-components-popup.heading',
		defaultMessage: 'A new way to work on software components',
		description: 'Heading text for the spotlight message explaining Compass components.',
	},
	summary: {
		id: 'project-components.compass-components-popup.summary',
		defaultMessage:
			'Use Compass components to group and track work around pieces of your software architecture.',
		description: 'Summary text for the spotlight message explaining Compass components.',
	},
	learnMore: {
		id: 'project-components.compass-components-popup.learn-more',
		defaultMessage: 'Show me',
		description:
			'Button text for opening additional information associated with the Compass components spotlight.',
	},
	dismiss: {
		id: 'project-components.compass-components-popup.dismiss',
		defaultMessage: 'Dismiss',
		description:
			'Button text for closing the Compass components dialog without viewing additional information.',
	},
});
